module.exports = __webpack_public_path__ + "static/media/icon-youtube.712c39a2.svg";